module.exports = __webpack_public_path__ + "img/dashboard-active.7d40711.png";